import { useState } from 'react'
import { Drawer, IconButton, iconSizes, Stack, Text, Title, Tooltip } from '@common/ui'
import { IconHistory } from '@common/ui/icons'
import { com } from '@eidu/web'
import VersionHistory from './VersionHistory'
import EntityId = com.eidu.entity.EntityId

type VersionHistoryDrawerProps = {
  entityId: EntityId
  initialOpen?: boolean
  initialCompareVersionId?: string
}

const DRAWER_WIDTH = 420

const VersionHistoryDrawer = ({
  entityId,
  initialOpen = false,
  initialCompareVersionId,
}: VersionHistoryDrawerProps) => {
  const [open, setOpen] = useState(initialOpen || !!initialCompareVersionId)

  return (
    <>
      <Tooltip label="Version history">
        <IconButton onClick={() => setOpen(true)} aria-label="Open version history" data-testid="version-history-open">
          <IconHistory size={iconSizes.sm} stroke={1.5} />
        </IconButton>
      </Tooltip>
      <Drawer
        position="right"
        opened={open}
        onClose={() => setOpen(false)}
        size={DRAWER_WIDTH}
        closeButtonProps={{ 'aria-label': 'Close version history' }}
        title={
          <Stack gap={0}>
            <Text size="xs" tt="uppercase" c="dimmed" lts={1}>
              Published
            </Text>
            <Title order={4}>Version history</Title>
          </Stack>
        }
      >
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
          <VersionHistory entityId={entityId} initialCompareVersionId={initialCompareVersionId} />
        </div>
      </Drawer>
    </>
  )
}

export default VersionHistoryDrawer
